<template>
  <div class="min-h-screen max-h-screen">
    <div
      v-show="lockView"
      class="absolute flex h-full w-full items-center justify-center text-xl leading-xl font-light font-vw-head"
    >
      Gira el móvil para sumergirte en la experiencia.
    </div>

    <div v-show="!lockView">
      <AppHeader
        v-if="$route.name !== '404'"
        :color="color"
      />

      <router-view
        :breakpoint="breakpoint"
        @update-menu-color="updateMenuColor"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import AppHeader from './Header.vue'

export default {
  components: {
    AppHeader
  },

  data () {
    return {
      color: 'white',
      lockView: false,
      breakpoint: 0
    }
  },

  created () {
    this.checkOrientation()
    this.refreshBreakpoint()

    window.addEventListener('resize', _.throttle(this.checkOrientation))
    window.addEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  destroyed () {
    window.addEventListener('resize', _.throttle(this.checkOrientation))
    window.addEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  methods: {
    refreshBreakpoint () {
      this.breakpoint = parseInt(window
        .getComputedStyle(document.querySelector('body'), ':before')
        .getPropertyValue('content')
        .replace(/"/g, ''))
    },

    updateMenuColor (color) {
      this.color = color
    },

    checkOrientation () {
      const windowHeight = document.documentElement.clientHeight ||
                           document.getElementsByTagName('body')[0].clientHeight
      const windowWidth = document.documentElement.clientWidth ||
                          document.getElementsByTagName('body')[0].clientWidth

      this.lockView = windowHeight < 500 && windowWidth < 900
    }
  }
}
</script>
